import { Chip, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react'
import StyledTableContainer from '../../../../../newTestPrep/newComponent/TableContainer';
import { fDate } from '../../../../../utils/formatTime';

function ViewProgramHistory({ programs, loading, setPrograms, isReadOnly }) {
    const userId = localStorage.getItem("userId");
    const userRole = localStorage.getItem("userRole");

  return (
    <>
      <Typography textAlign="left" variant="h4" fontWeight={700}>
        Program History
      </Typography>
      {loading ? (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      ) : (
        <>
          {programs.length === 0 ? (
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h5">No program history available</Typography>
            </Grid>
          ) : (
            <StyledTableContainer
              component={Paper}
              sx={{ borderRadius: "15px", padding: "10px" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontFamily: "Poppins",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                      }}
                    >
                      Program Details
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontFamily: "Poppins",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                      }}
                    >
                      Branch Enrolled
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontFamily: "Poppins",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                      }}
                    >
                      Package Details
                    </TableCell>

                    <TableCell
                      sx={{
                        color: "#000",
                        fontFamily: "Poppins",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                      }}
                    >
                      Enrollment Date
                    </TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell>Program Intake</TableCell>
                      <TableCell>Currency</TableCell>
                    <TableCell>Amount to be paid</TableCell>
                    <TableCell>Amount Paid</TableCell>
                    <TableCell>Enrolled By</TableCell>
                    <TableCell>Status</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  <>
                    {programs.map((row, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f0f0f0" : "inherit",
                          width: "6%",
                        }}
                      >
                        <TableCell>{row?.scholars_program_id?.name}</TableCell>
                        <TableCell>{row?.branch_enrolled_by?.branch_name}</TableCell>
                        <TableCell>
                          {row?.package_id?.package_name}
                          <br />
                          {row?.package_days} session(s)
                        </TableCell>
                        <TableCell>{fDate(row?.enrollment_date)}</TableCell>
                        <TableCell>{fDate(row?.end_date)}</TableCell>
                        <TableCell>
                          {row?.sap_month_intake?.month_full_name}
                          <br />
                          {row?.sap_year_intake}
                        </TableCell>
                               <TableCell>{row?.currency}</TableCell>
                        <TableCell>{row?.amount_to_be_paid}</TableCell>
                        <TableCell>{row?.amount_paid}</TableCell>
                        <TableCell>{row?.created_by?.first_name}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            variant="contained"
                            label={row?.is_active == 1 ? "Active": "Inactive"}
                            color={
                              row?.is_active === 1
                                ? "secondary"
                                : "error"
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </>
      )}
    </>
  )
}

export default ViewProgramHistory